import { SVGProps, Ref, forwardRef } from 'react';

export const ImageStackFilledSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M16 1.334c6.722 0 10.14.46 11.407 2.888-1.015-.392-2.123-.655-3.29-.839-2.236-.352-4.949-.45-8.117-.45s-5.88.098-8.118.45c-1.167.184-2.274.447-3.29.84C5.86 1.794 9.277 1.332 16 1.332"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.61 18C.3 6.917 3.407 5.334 16 5.334S31.699 6.917 30.39 18c-.26 2.213-.541 4.048-.913 5.566l-6.647-4.812-4.557 3.14-6.822-4.693-8.925 6.377c-.373-1.52-.655-3.359-.917-5.578M21 12c-1.75 0-2.333 1.167-2.333 2.334 0 1.166.583 2.333 2.333 2.333s2.333-1.167 2.333-2.334C23.333 13.168 22.75 12 21 12"
                fill="currentColor"
            />
            <path
                d="m22.796 21.692 5.9 4.273C26.97 29.933 23.685 30.667 16 30.667c-7.68 0-10.966-.734-12.694-4.696l8.171-5.839 6.797 4.676z"
                fill="currentColor"
            />
        </g>
    </svg>
));
ImageStackFilledSize32Glyph.displayName = 'ImageStackFilledSize32Glyph';
